import type { RouteLocationNormalized } from 'vue-router'

export const manualUserNavigationGuard =
  (fallback: string) => (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    const { navigateToLocalized } = useRouterUtils()
    if (to.fullPath === from.fullPath) {
      const { redirect, ...rest } = to.query
      return navigateToLocalized({ path: fallback, query: rest })
    }
  }
